/** The embedded catalog uses the real route and session, but never submits business changes. */
export function installCatalogReadOnly() {
    if (window.parent === window || window.name !== 'withpot-catalog-preview') return;
    const denied = () => new Error('组件库只预览使用场景，请在业务页面执行保存或提交。');
    const readable = (method: string, url: string) => {
        const target = new URL(url, window.location.href);
        return ['GET','HEAD','OPTIONS'].includes(method.toUpperCase())
            && !/\/(logout|delete|remove|callback)(\/|\?|$)/i.test(target.pathname);
    };
    // Keep drafts and preferences inside the preview frame, including logout cleanup.
    const stores = new Map<Storage, Map<string,string>>();
    for (const storage of [window.localStorage, window.sessionStorage]) {
        const snapshot = new Map<string,string>();
        for (let index=0;index<storage.length;index++) {const key=storage.key(index);if(key!==null) snapshot.set(key,storage.getItem(key)!);}
        stores.set(storage,snapshot);
    }
    const getItem = Storage.prototype.getItem;
    Storage.prototype.getItem = function(key) {return stores.get(this)?.get(String(key)) ?? (stores.has(this) ? null : getItem.call(this,key));};
    Storage.prototype.setItem = function(key,value) {stores.get(this)?.set(String(key),String(value));};
    Storage.prototype.removeItem = function(key) {stores.get(this)?.delete(String(key));};
    Storage.prototype.clear = function() {stores.get(this)?.clear();};
    const fetch = window.fetch.bind(window);
    window.fetch = (input, init) => {
        const request = input instanceof Request ? input : null;
        if (!readable(init?.method ?? request?.method ?? 'GET', request?.url ?? String(input))) return Promise.reject(denied());
        return fetch(input, init);
    };
    const open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(this: XMLHttpRequest, method: string, url: string | URL, ...args: any[]) {
        if (!readable(method, String(url))) throw denied();
        return (open as Function).call(this, method, url, ...args);
    } as typeof open;
    navigator.sendBeacon = () => false;
    window.open = () => null;
    // Router navigation stays in this frame. Full document navigation could leave preview mode.
    document.addEventListener('click', event => {
        const link = (event.target as Element)?.closest?.('a');
        if (link) event.preventDefault();
    }, true);
    document.addEventListener('submit', event => event.preventDefault(), true);
    HTMLFormElement.prototype.submit = () => { throw denied(); };
}

installCatalogReadOnly();
